"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKeyboardActivateHandler = exports.stopActivationKeyPropagation = exports.isKeyboardActivationKey = void 0;
/**
 * Whether a key should activate a selectable control (Enter or Space).
 * @param key - KeyboardEvent.key value
 * @returns True when the key activates button-like controls
 */
const isKeyboardActivationKey = (key) => key === 'Enter' || key === ' ';
exports.isKeyboardActivationKey = isKeyboardActivationKey;
/**
 * Stops bubbling for activation keys only so other keys can reach ancestor handlers.
 * @param event - Keyboard event from a nested interactive control
 */
const stopActivationKeyPropagation = (event) => {
    if ((0, exports.isKeyboardActivationKey)(event.key)) {
        event.stopPropagation();
    }
};
exports.stopActivationKeyPropagation = stopActivationKeyPropagation;
/**
 * Returns an `onKeyDown` handler that activates the action on Enter or Space.
 * @param activate - Callback to run when the key press should activate the control
 * @param options - Optional keyboard handler behaviour
 * @returns Keyboard event handler for selectable widgets
 */
const createKeyboardActivateHandler = (activate, options) => (event) => {
    if ((0, exports.isKeyboardActivationKey)(event.key)) {
        event.preventDefault();
        activate();
        if (options === null || options === void 0 ? void 0 : options.stopPropagation) {
            event.stopPropagation();
        }
    }
};
exports.createKeyboardActivateHandler = createKeyboardActivateHandler;
//# sourceMappingURL=selectableKeyboard.js.map